import { useMemo } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { Components } from 'react-markdown';
import './MarkdownDisplay.css';

export interface MarkdownDisplayProps {
  content: string;
  className?: string;
}

/**
 * Markdownコンテンツ表示コンポーネント
 *
 * セキュリティ対策:
 * - XSS対策: skipHtml={true}でHTMLタグを無効化
 * - 外部リンクにrel="noopener noreferrer"を付与
 */
export function MarkdownDisplay({ content, className }: MarkdownDisplayProps) {
  const components = useMemo<Components>(
    () => ({
      // リンクのセキュリティ強化
      a: ({ ...props }) => {
        const href = props.href || '';
        const isExternal = href.startsWith('http');

        return (
          <a
            {...props}
            rel={isExternal ? 'noopener noreferrer' : undefined}
            target={isExternal ? '_blank' : undefined}
          />
        );
      },

      // コードブロックのスタイリング
      code: (props) => {
        const { className, children, ...rest } = props;
        // クラス名にlanguage-が含まれていればブロック、含まれていなければインライン
        const isBlock = className?.includes('language-');
        return (
          <code className={isBlock ? 'code-block' : 'inline-code'} {...rest}>
            {children}
          </code>
        );
      },
    }),
    []
  );

  if (!content) {
    return null;
  }

  return (
    <div className={`markdown-display ${className || ''}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml={true}
        components={components}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
